import React from "react";
import styles from "./style.module.scss";
import ContactUsForm from "@components/shared/contactUs/contactUsForm";
import Image from "next/image";
// import LocationIcon from "./icons/locationIcon";
// import PhoneIcon from "./icons/phoneIcon";
// import MailIcon from "./icons/mailIcon";
import { motion } from "framer-motion";
import { DomainInfo } from "@components/severalbrands/utils/services";

// const list = [
//     // {
//     //     icon: <LocationIcon />,
//     //     description: "2810 N Church St #56440 Wilmington, DE 19802",
//     // },
//     { icon: <PhoneIcon />, description: "+1 (888) 896-5558" },
//     { icon: <MailIcon />, description: "team@severalbrands.com" },
// ];
const FormSection = ({ domainInfo }: { domainInfo: DomainInfo }) => {
    return (
        <div className={`${styles["bgStyle"]} px-4`}>
            <div className="lg:pt-6 pt-12 pb-24 lg:pl-4 3xl:pl-24   ">
                <motion.div
                    transition={{ duration: 1.5 }}
                    initial={{ opacity: 0, y: 150 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="flex flex-col lg:flex-row 3xl:gap-52 lg:gap-32   "
                >
                    <div className="3xl:max-w-[800px] max-w-[600px] lg:mt-20 ">
                        <h1 className="font-bold text-[#323175]  3xl:text-7xl 3xl:leading-[4.5rem] lg:text-5xl text-3xl lg:leading-[3.5rem] leading-8">
                            Partner With Us
                        </h1>
                        <p className="3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 font-light mt-3 mb-3 ">
                            Partner with our expert team to generate
                            high-quality leads and increase your sales revenue.
                            Contact us today.
                        </p>

                        <div className={`${styles.form}`}>
                            <ContactUsForm
                                primaryColor={"#ef4f80"}
                                secondaryColor="#000000"
                                classes={{
                                    formClassName: styles["form"],
                                    fieldWrapperClassName:
                                        styles["field-wrapper"],
                                    fieldClassName: styles["field"],
                                    fieldErrorClassName: styles["errorStyle"],
                                    thankYouStepClassName:
                                        styles["thankYouStyle"],
                                }}
                                domainInfo={domainInfo}
                                severalBrandsRecaptcha
                            />
                        </div>
                    </div>
                    <div
                        className={`mx-auto lg:mx-0  md:w-[460px] md:min-w-[460px] md:h-[791px] 3xl:w-[660px] 3xl:min-w-[660px] 3xl:h-[991px] relative `}
                    >
                        <Image
                            src={
                                "/severalbrands/assets/images/partnerWithUsImg2.png"
                            }
                            alt="img"
                            layout="fill"
                            objectFit="contain"
                            priority
                        />
                    </div>
                </motion.div>

                {/* <motion.div
                    transition={{ duration: 1.5 }}
                    initial={{ opacity: 0, y: 150 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="mt-28"
                >
                    <h3 className="font-bold text-[#323175] 3xl:text-7xl 3xl:leading-[3.5rem] lg:text-5xl text-3xl lg:leading-10 leading-8 ">
                        Office Location
                    </h3>
                    {list.map((el, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-4 mt-4 first-of-type:mt-8"
                        >
                            <span className="block relative w-[25px] h-[25px] 3xl:w-[35px] 3xl:h-[35px]">
                                {el.icon}
                            </span>
                            <p className="3xl:text-xl font-light">
                                {el.description}
                            </p>
                        </div>
                    ))}
                </motion.div> */}
            </div>
        </div>
    );
};
export default FormSection;
